module.exports = __webpack_public_path__ + "img/avatar1.b0c46391.png";